import * as React from "react";
import { s as shimExports } from "../../../../../_virtual/index.js";
import { NOOP } from "../../../utils/empty.js";
function usePopupHandleStore(handle) {
  const subscribe = React.useCallback((listener) => {
    if (handle === void 0) {
      return NOOP;
    }
    return handle.subscribeStore(listener);
  }, [handle]);
  const getSnapshot = React.useCallback(() => {
    return handle === void 0 ? void 0 : handle.store;
  }, [handle]);
  return shimExports.useSyncExternalStore(subscribe, getSnapshot, () => handle?.serverStore);
}
export {
  usePopupHandleStore
};
//# sourceMappingURL=usePopupHandleStore.js.map
